//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import treetag from "@/pccomponents/TreeTag";
import NoDataDisplay from "@/pccomponents/NoDataDisplay";

export default {
  name:'SelectTreeTagInfo',
  components: {
		treetag,
		NoDataDisplay
  },
  props:{
    // sys_cselectpub表的selectwintype字段
    selectWinType:{
      type: String,
      default: ''
    },
    // 左侧树选择的形式：单选common、多选checkbox
    selectType:{
      type: String,
      default: 'common'
    },
    // 当前行项的index
    rowindex:{
      type: Number,
      default: -1
    },
    // 回调函数
    callbackFun:{
      type:Function,
      default:null
    },
    // 弹出框所需数据
    bindData:{
      type:Object,
      default: () => ({})
    },
    // 编辑项
    editItem:{
      type:String,
      default:''
    },
    // 匹配的编辑项
    matchItem:{
      type:String
    },
    // 选择框标题
    title:{
      type: String,
      default: ''
    },
    // 清空的图标
    clearIcon: {
      type: String,
      default: "el-icon-close"
    },
    // 打开选择的图标
    openIcon: {
      type: String,
      default: "el-icon-files"
    },
    // 是否隐藏按钮的内容
    hideSpan: {
      type: Boolean,
      default: true
    },
    // 输入框是否有值，有值才显示清除值的按钮
    hasVal: {
        type: String,
        default: ""
    },
    // 传入参数
    scon: {
      type: String,
      default: '1'
    },
    // 返回类型默认为'0'，为'2'时，将在确认选择后，从后台再次获取sys_cselectpub表中的returnsqlname字段的查询值
    returnType:{
      type:String,
      default:'0'
    },
    // 传入父组件返回同步数据的信息字段名，用于在没有回调函数且未打开过弹窗一次的情况下，清空方法进行取值
    configParams:{
      type:Array,
      default: () => []
    },
    // 点击树形节点,添加节点信息到右侧前执行
    // 参数data为点击的节点的信息
    befAddNode:{
      type:Function,
      default:null
    },
    //打开弹出框前执行
    beforeOpenSelect:{
      type:Function,
      require: false
    },
    beforeSubmitSelect:{
      type:Function,
      require: false
    },
    //树是否懒加载
    lazy: {
      type: Boolean,
      default: true
    },
    flowsysid:{
      type:String,
      default:''
    },
  },
  data() {
    return {
      dialogVisible: false,//控制弹出框的显示
      deptList: [],//存储左侧的树列表数据
      selectData:[],//选择后，所获得的数据，用于向后台查询，获得最终右侧显示的数据
      showData:[],//最终右侧显示的数据
      showDataFormat:[],//最终右侧显示的数据的格式
      returnData:{},//用于保存向父组件返回同步数据
      
      treeCode:'',//设置树的对应码，存放sys_cselectpub的TREECODE字段，对应树配置表sys_treeconfig内的TREECODE
      
      treetagID:'treeTag',
      treeID:'leftTree',

      //存储传入的值
      vSelectWinType:this.selectWinType,
      vSelectType:this.selectType,
      vbindData:this.bindData,
      vtitle:this.title,
      vscon:this.scon,
      vconfigParams:this.configParams,//用于定义向父组件返回同步数据的信息字段名
    }
  },
  created() {
    
  },
  mounted() {
  },
  methods: {
    //初始化树结构
    async initTree(){
        let url = "selectPubController/getSelectPubTree";
        let params = {
          selectwintype : this.vSelectWinType,
          selecttype:this.vSelectType,
          defparas : '',
          cond : '',
          selectid : '',
          flowsysid:this.flowsysid,
        };
        await this.axios.post(url, params).then(({ data }) => {
          if(data.code=='1'){
            this.vbindData=data.data;
            this.showDataFormat=data.data.showinfo;

            //将selectfield字段以逗号分隔存为数组
            let selectfields=[...data.data.configinfo.selectfield.split(',')];
            for(let i=0;i<selectfields.length;i++){
              //获取逗号分隔的每个数据的最后一个词
              let strs=selectfields[i].split(" ");
              selectfields[i]=strs[strs.length-1];
            }
            this.vconfigParams=selectfields;

            this.treeCode=data.data.configinfo.treecode;
            this.vtitle=data.data.configinfo.chselectwintype;//标题
            this.dialogVisible=true;//在数据加载后，才渲染，保证渲染时treetag组件所需的treeCode已获取
          }else{
            console.log('2019年11月26日18:56:01 SelectTreeTagInfo.vue[树-行项选择框，后台初始化树结构失败]——[error] :',data.msg);
          }
        }).catch(function(error){
          console.log('2019年11月26日18:56:01 SelectTreeTagInfo.vue[树-行项选择框，前台初始化树结构失败]——[error] :',error);
        })
    },
    /**
     * 打开选择框
     */
    openSelectData(){
      let flag = true;
      try {
        if(this.beforeOpenSelect){
          flag = this.beforeOpenSelect();
        }
      } catch (error) {
        flag = false;
      }
      if(flag){
        //存储传入的值
        this.vSelectWinType=this.selectWinType;
        this.vSelectType=this.selectType;
        this.vbindData=this.bindData;
        this.vtitle=this.title;
        this.vscon=this.scon;

        //当传入bindData时，初始化所需值
        if(Object.keys(this.vbindData).length!=0){
          this.vSelectWinType=this.vbindData.selectwintype;
          this.vSelectType=this.vbindData.selecttype;
          this.vscon=this.vbindData.scon;
          // this.vtitle=this.vbindData.configinfo.chselectwintype;
        }
        this.initTree();
      }
    },
    /**
     * 点击确认，回写信息到表单
     */
    submitSelectData() {
      if(this.beforeSubmitSelect){
        let params = {
            rowindex : this.rowindex,
            returnData :  this.showData
        }
        if(!this.beforeSubmitSelect(params)){
          return false;
        }
      }
      this.dialogVisible = false;

      if(this.callbackFun){
        //有回调函数，传入的同步数据是对象时使用
        let params = {
            rowindex : this.rowindex,
            returnData :  this.showData
        }
        this.callbackFun(params,this.vbindData.configinfo.selectid);//this.vbindData.configinfo.selectid为内嵌时回传的值
      }else{
        //没有回调函数，传入的同步数据是字符串时使用
        for(let configParam of this.vconfigParams){
            let echoData=''
            for(let dataCollect of this.showData){
              if(echoData==''){
                echoData=dataCollect[configParam]
              }else{
                echoData=echoData+';'+dataCollect[configParam]
              }
            }
            this.$emit('update:'+configParam, echoData)
        }
      }

      //清空右侧行项列表的选择状态
      this.showData=[];
    },
    /**
     * 点击清空
     */
    clearSelectData(){
      //清空回填的数据
      if(this.callbackFun){
        //有回调函数，传入的同步数据是对象时使用
        let returnData=[];
        let obj={};
        for(let i=0;i<this.vconfigParams.length;i++){
          obj[this.vconfigParams[i]] = '';
        }
        returnData.push(obj);
        this.showData=[];

        let params = {
            rowindex : this.rowindex,
            returnData : returnData
        }
        this.callbackFun(params);
      }else{
        //没有回调函数，传入的同步数据是字符串时使用
        if(this.configParams.length > 0){
          for(let configParam of this.vconfigParams){
              this.$emit('update:'+configParam, '')
          }
        }else{
          for (let sKey in this.$attrs) {
            this.$emit("update:" + sKey, "");
          }
        }
      }

      //清空左侧树的选择状态
      this.deptList=[];
      //清空右侧行项列表的选择状态
      this.selectData=[];
    },
    /**
     * 点击取消按钮，关闭弹出框
     */
    cancelSelect() {
      //清空右侧行项列表的选择状态
      this.showData=[];
      
      this.dialogVisible = false;
    },
    /**
     * 点击树形节点回调函数,选择左边树内容到右侧行项列表(单选时为直接赋值，复选时为push累加)
     */
    async treeClick(treeNode) {
      if(this.vSelectType=='common'){
        //选择的树可单选
        let url = "selectPubController/getSelectPubTreeReturn";
        let params = {
          selectwintype : this.vSelectWinType,
          selectid: treeNode.id,
          returntype:this.returnType,
          selecttype:this.vSelectType,
          flowsysid:this.flowsysid,
        };
        await this.axios.post(url, params).then(async ({ data }) => {
          let isAdd=true;//是否添加
          if(this.befAddNode){
            isAdd=await this.befAddNode(data).then((result)=>{
              return result;
            });
          }
          if(isAdd){
            this.showData.length=0;
            this.showData.push(...data.data.returndata);
          }
        });
      }else if(this.vSelectType=='checkbox'){
        //选择的树可复选
        let url = "selectPubController/getSelectPubTreeReturn";
        let params = {
          selectwintype : this.vSelectWinType,
          selectid: treeNode.id,
          returntype:this.returnType,
          selecttype:this.vSelectType,
          flowsysid:this.flowsysid,
        };
        await this.axios.post(url, params).then(async ({ data }) => {
          let isAdd=true;//是否添加
          if(this.befAddNode){
            isAdd=await this.befAddNode(data).then((result)=>{
              return result;
            });
          }
          if(isAdd){
            //判断是否已存在，若不存在则追加
            let flag =true;
            if(this.showData&&this.showData.length!=0){
              this.showData.forEach(item=>{
                let count=0;
                for(let configParam of this.vconfigParams){
                  if(item[configParam]==data.data.returndata[0][configParam]){
                    count++;
                  }
                }
                if(count==this.vconfigParams.length){
                  flag =false;
                }
              });
            }
            if(flag){
              this.showData.push(...data.data.returndata);
            }
          }

          //选中相应的多选框
          let allKeys=this.$refs[this.treetagID].$refs[this.treeID].getCheckedKeys();
          let selItem=data.data.returndata[0][this.vbindData.configinfo.selectid];//选中项的key对应的值
          allKeys.push(selItem);
          let setKeys = new Set([...allKeys]);
          let arrSetKeys =Array.from(setKeys)
          this.$refs[this.treetagID].$refs[this.treeID].setCheckedKeys(arrSetKeys);
        });
      }
    },
    /**
     * 复选时的点击事件，用于中间箭头,将左边树的选中内容填入右侧行项列表
     */
    selectPluralDataClick() {
      let showDatas=this.$refs[this.treetagID].$refs[this.treeID].getCheckedNodes();
      let selectid='';
      for(let showData of showDatas){
        if(showData.disabled){
          continue;
        }
        if(selectid==''){
          selectid=showData.id;
        }else{
          selectid=selectid+','+showData.id;
        }
      }

      //当没有选中复选框时，传入-1使其返回空
      if(selectid==''){
        selectid=-1;
      }

      let url = "selectPubController/getSelectPubTreeReturn";
      let params = {
        selectwintype : this.vSelectWinType,
        selectid: selectid,
        returntype:this.returnType,
        selecttype:this.vSelectType,
        flowsysid:this.flowsysid,
      };
      this.axios.post(url, params).then(({ data }) => {
        this.showData.length=0;

        this.showData.push(...data.data.returndata);
      });
    },
    /**
     * 双击删除已选
     */
    delDblclick(row) {
      for (let i = 0; i < this.showData.length; i++) {
        if (this.showData[i] === row) {

          //取消弹窗左侧树的相应项
          let selItem=this.showData[i][this.vbindData.configinfo.selectid];//删除项的key对应的值
          let sels=this.$refs[this.treetagID].$refs[this.treeID].getCheckedKeys(true,false);
          let j=0;
          for(;j<sels.length;j++){
            if(sels[j]==selItem+''){
              sels.splice(j, 1);
              break;
            }
          }
          this.$refs[this.treetagID].$refs[this.treeID].setCheckedKeys(sels);

          //删除弹窗右侧已选相应项
          this.showData.splice(i, 1);

          break;
        }
      }
    },
    openModel() {
        this.setDialogPos();
    }
  },
  computed: {
    readonly: function () {
      if(this.editItem.indexOf(';'+this.matchItem+';')===-1){
        return false;
      }else{
        //若编辑域有该值则显示
        return true;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pccomponents/SelectTreeTagInfo.vue